'use client';
import { useAuth, useOrganization, useUser } from '@clerk/nextjs';
import { usePathname, useSearchParams } from 'next/navigation';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

/*
 * Use this component if any only if posthog feature is enabled
 */
function Capture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  const { isSignedIn, userId } = useAuth();
  const { user } = useUser();
  const { organization } = useOrganization();

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams, posthog]);

  useEffect(() => {
    // 👉 Check the sign-in status and user info,
    //    and identify the user if they aren't already
    if (isSignedIn && !!userId && user && organization && !posthog._isIdentified()) {
      // Identify the user

      posthog.identify(userId, {
        'User email': user.primaryEmailAddress?.emailAddress,
        'User name': user?.fullName,
        'User id': userId,
        'Org name': organization?.name,
      });
    }

    // Reset the user if they sign out
    if (!isSignedIn && posthog._isIdentified()) {
      posthog.reset();
    }
  }, [posthog, userId, user, organization, isSignedIn]);

  return null;
}

export { Capture };
